import {
    GET_HOLIDAYS,
    UPDATE_HOLIDAY,
    CREATE_HOLIDAY,
    DELETE_HOLIDAY,
} from '../actions/holidays';
import _ from 'lodash';

const INITIAL_STATE = [];

export default function (state = INITIAL_STATE, action) {
    let index = -1;
    switch (action.type) {
        case GET_HOLIDAYS:
            return [].concat(action.value);

        case UPDATE_HOLIDAY:
            index = _.findIndex(state, { '_id':  action.value._id});
            state[index] = action.value;
            return [].concat(state);

        case CREATE_HOLIDAY:
            return [action.value].concat(state);

        case DELETE_HOLIDAY:
            index = _.findIndex(state, { '_id':  action.value._id});
            if (index !== -1) {
                state.splice(index, 1);
            }
            return [].concat(state);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/holidays.js